import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import {
  edit_icon,
  Search_icon,
  small_calendar,
  small_time,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { formatKey } from "../redux/api/Constants";

const AnnoucementBannerList = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { paginationData, setpaginationData } = useGlobalContext();
  const path = pathname?.replace("/", "");
  const [active, setActive] = useState(
    paginationData?.[path]?.active ?? "User",
  );
  const [search, setSearch] = useState("");

  const [pagination, setPagination] = useState(
    paginationData?.[path]?.pagination ?? {
      User: {},
      Hotels: {},
    },
  );
  const [list, setList] = useState({ User: [], Hotels: [] });

  const [dateTimeToggle, setDateTimeToggle] = useState({
    User: false,
    Hotels: false,
  });

  const [dateTime, setDateTime] = useState({
    User: {
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    },
    Hotels: {
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    },
  });

  const inputRefs = useRef({});

  const DATE_FMT = "YYYY-MM-DD"; // stored + input value
  const TIME_FMT = "HH:mm"; // stored + input value

  const isTimeKey = (key) => key.toLowerCase().includes("time");

  const openPicker = (key) => {
    const input = inputRefs.current[key];
    if (!input) return;
    try {
      input.showPicker?.();
    } catch {
      input.focus();
      input.click();
    }
  };

  const displayValue = (key, value) => {
    if (!value) return "Select";
    return isTimeKey(key)
      ? moment(value, TIME_FMT).format("hh:mm A") // 04:30 PM
      : moment(value, DATE_FMT).format("DD MMM YYYY"); // 13 Oct 2026
  };

  const handleDateTimeChange = (key, value) => {
    const current = dateTime?.[active];
    const next = { ...current, [key]: value };

    if (
      key === "startDate" &&
      next.endDate &&
      moment(next.endDate, DATE_FMT).isBefore(moment(value, DATE_FMT))
    ) {
      next.endDate = "";
    }

    if (
      next.startDate &&
      next.startDate === next.endDate &&
      next.startTime &&
      next.endTime &&
      !moment(next.endTime, TIME_FMT).isAfter(moment(next.startTime, TIME_FMT))
    ) {
      toast.error("End time must be after start time");
      return;
    }

    setDateTime((prev) => ({ ...prev, [active]: next }));
  };

  const handleNavigation = (type, prob) => {
    navigate("/annoucement-banner-edit", {
      state: { type: type, ...(prob ?? {}) },
    });
  };

  const addToGlobal = (d = {}) => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], ...d },
    }));
  };

  const columns = React.useMemo(() => {
    return [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <p className="red">
              {(pagination?.[active]?.current_page - 1) * 10 + (row.index + 1)}
            </p>
          );
        },
      },
      {
        Header: "Category",
        accessor: "category",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "No: Videos",
        accessor: "no_of_videos",
        Cell: ({ value, row }) => {
          return (
            <p className="">
              {String(value ?? row.original?.no_of_banner).padStart(2, 0)}{" "}
              {value ? "Videos" : "Banners"}
            </p>
          );
        },
      },

      {
        Header: "Uploaded Date",
        accessor: "updated_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY hh:mm A")}</p>;
        },
      },
      {
        Header: "Display",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <img
                src={value ? toggle_on : toggle_off}
                className="roles-icon pointer"
                alt=""
                onClick={() => {
                  handleStatus(row.original);
                }}
              />
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js">
            <button
              onClick={() =>
                handleNavigation("edit", {
                  userType: active,
                  announcement_type: row.original?.announcement_type,
                  data: row.original?.banners ?? row.original?.videos,
                })
              }
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>

            <button
              onClick={() =>
                handleNavigation("view", {
                  announcement_type: row.original?.announcement_type,
                  userType: active,
                  data: row.original?.banners ?? row.original?.videos,
                })
              }
              className="cust-btn"
            >
              <img src={view_icon} alt="" className="mx-2 edit-btn" />
            </button>
          </div>
        ),
      },
    ];
  }, [pagination?.[active], list?.[active]]);
  
  //api functions

  const getList = async (page = 1, search) => {
    let res = await get(
      `${URLS.ANNOUNCEMENT_BANNER_LIST}?type=${active === "User" ? 1 : 2}${search ? "&search=" + search : ""}`,
    );
    if (res?.status === "success") {
      if (search && res?.data?.length === 0) toast.info("No Records Found...");
      setList((prev) => ({ ...prev, [active]: res?.data }));
      let annoucement_time = res?.annoucement_time;
      let dateTimeObj = {
        startDate: moment(annoucement_time?.maintenance_start_at).format(
          DATE_FMT,
        ),
        endDate: moment(annoucement_time?.maintenance_end_at).format(DATE_FMT),
        startTime: moment(annoucement_time?.maintenance_start_at).format(
          TIME_FMT,
        ),
        endTime: moment(annoucement_time?.maintenance_end_at).format(TIME_FMT),
      };
      setDateTime((prev) => ({ ...prev, [active]: dateTimeObj }));
      setDateTimeToggle((prev) => ({
        ...prev,
        [active]: annoucement_time?.status,
      }));
      addToGlobal({
        pagination: {
          ...[pagination],
          [active]: {
            current_page: page,
            last_page: res?.total_pages,
            count: res?.count,
          },
        },
        active: active,
      });
      setPagination((prev) => ({
        ...prev,
        [active]: {
          current_page: page,
          last_page: res?.total_pages,
          count: res?.count,
        },
      }));
    }
  };

  useEffect(() => {
    sessionStorage.setItem("annoucement-banner-list", "4");
    getList();
  }, [active]);

  const handleStatus = async (d) => {
    let found = (list?.[active] ?? [])?.find(
      (item) => item?.status_type !== d?.status_type,
    );
    console.log("staus changer", found, d);
    if (found?.status && !d?.status) {
      toast.error(
        "You can enable either the Announcement Banner or the Video, but not both at the same time. ",
      );
      return;
    }
    let payload = {
      type: d?.status_type,
      status: !d?.status,
    };
    let res = await post(`${URLS.ANNOUNCEMENT_BANNER_STATUS}`, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      setList((prev) => ({
        ...prev,
        [active]: prev?.[active].map((item) =>
          item?.status_type === d?.status_type
            ? { ...item, status: !d?.status }
            : item,
        ),
      }));
    }
  };

  const updateDateTime = async () => {
    let { startDate, startTime, endDate, endTime } = dateTime?.[active];
    console.log("date time data", dateTime);
    let payload = {
      type: active === "User" ? 33 : 32, 
      status: dateTimeToggle?.[active],
      maintenance_start_at: moment(
        `${startDate} ${startTime}`,
        "YYYY-MM-DD HH:mm",
      ).toISOString(),
      maintenance_end_at: moment(
        `${endDate} ${endTime}`,
        "YYYY-MM-DD HH:mm",
      ).toISOString(),
    };
    let res = await post(URLS.ANNOUNCEMENT_BANNER_DATE_TIME_UPDATE, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
    }
  };

  return (
    <div>
      <Topbar header={"Announcement Banner/video"} back={true} />
      <div className="d-flex ac-jb">
        <div className="d-flex gap-3">
          {["User", "Hotels"].map((ele) => {
            return (
              <div
                key={ele}
                style={{
                  background: active == ele ? "#AE55F5" : "#78788029",
                  padding: "10px 30px",
                  borderRadius: 7,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSearch("");
                  setActive(ele);
                }}
              >
                <p style={{ color: active == ele ? "#fff" : "#000" }}>{ele}</p>
              </div>
            );
          })}
        </div>

        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                let val = e.target.value;
                setSearch(val);
                if (!val || val?.length >= 3) getList(1, val);
              }}
              value={search}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>
        </div>
      </div>
      <h2 className="f1 mt-3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
        Total No: {String(pagination?.[active]?.count ?? 0).padStart(2, 0)}
      </h2>

      <Table
        columns={columns}
        setPageno={(page) => {
          let pageCount = pagination?.[active] ?? {};
          if (pageCount?.current_page < pageCount?.last_page) getList(page);
        }}
        pagecount={pagination?.[active] ?? {}}
        data={list?.[active] ?? []}
        show={true}
      />

      <div className="mt-4  d-flex ac-js gap-5">
        <h2 className="f2  fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-3">
          Selected date & time
        </h2>
        <img
          onClick={() =>
            setDateTimeToggle((prev) => ({
              ...prev,
              [active]: !prev?.[active],
            }))
          }
          src={dateTimeToggle[active] ? toggle_on : toggle_off}
          className="roles-icon pointer"
          alt=""
        />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          columnGap: "40px",
          maxWidth: "500px",
        }}
      >
        {Object.entries(dateTime?.[active] ?? {}).map(([key, value]) => (
          <div
            key={key}
            className="d-flex ac-jb my-3"
            style={{ position: "relative", cursor: "pointer" }}
            onClick={() => openPicker(key)}
          >
            <p className="f2 gray">
              {formatKey(key)} : {displayValue(key, value)}
            </p>

            <img
              src={isTimeKey(key) ? small_time : small_calendar}
              style={{ height: "20px", width: "20px" }}
              alt=""
            />

            <input
              ref={(el) => (inputRefs.current[key] = el)}
              type={isTimeKey(key) ? "time" : "date"}
              value={value}
              min={
                key === "endDate" && dateTime?.[active].startDate
                  ? dateTime?.[active].startDate
                  : key === "startDate"
                    ? moment().format(DATE_FMT) // optional: block past dates
                    : undefined
              }
              onChange={(e) => handleDateTimeChange(key, e.target.value)}
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
                pointerEvents: "none",
              }}
              tabIndex={-1}
            />
          </div>
        ))}
        <button
          onClick={updateDateTime}
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 border-0 white bg-primary1 video-submit-btn"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default AnnoucementBannerList;
